const toggleDisplayStateDocument = () => {
    const elGroupStateDocument = document.querySelector('#group-state-document');
    const elInputDocument = document.querySelector('#document');

    if (elInputDocument.value.length > 14) {
        elGroupStateDocument.classList.remove('d-none');
    }

    elInputDocument.addEventListener('blur', (event) => {
            if (event.target.value.length > 14) {
                elGroupStateDocument.classList.remove('d-none');
            } else {
                elGroupStateDocument.classList.add('d-none');
            }
        });
};

const maskInputData = () => {
    let CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    };

    let cpfCnpjpOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        },
    };

    $('#document').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);
};

const miscellaneous = () => {
};

export default () => {
    if (!document.getElementById('personalData')) return;
    miscellaneous();
    maskInputData();
    toggleDisplayStateDocument();
}



// WEBPACK FOOTER //
// ./scripts/routes/views/partials/dashboard-pages/personalData.js